import { GiftCard } from '../models/gift-card.model';

const coinsToInteger = (number: number): number => {
  return number / 100;
};

export const dataToGiftCard = (data: any): GiftCard  => {
  return new GiftCard(
    coinsToInteger(data.balance),
    data.state
  );
};

